package com.schoolconnect.app.feature.teachers

data class TeachersUiState(
    val isLoading: Boolean = false,
    val errorMessage: String = "",
    val searchQuery: String = "",
    val selectedId: String = "",
    val items: List<String> = emptyList()
)

sealed interface TeachersUiEvent {
    data object BackClicked : TeachersUiEvent
    data object RefreshClicked : TeachersUiEvent
    data class SearchChanged(val query: String) : TeachersUiEvent
}

